import { configure } from 'mobx';

configure({ isolateGlobalState: true });

import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterOutlet } from './routerOutlet';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import './index.css';

const prod = {
    apiKey: "AIzaSyBB4SdaWVUryNknzSK8uhVHSSa1UaRPmr8",
    authDomain: "design-with-friends.firebaseapp.com",
    databaseURL: "https://design-with-friends.firebaseio.com",
    projectId: "design-with-friends",
};

firebase.initializeApp(prod);

const db = firebase.firestore();

export const getDB = () => db;

const root = createRoot(document.getElementById('root'));
root.render(<RouterOutlet />);
// react-scripts 5 emits no service-worker.js, so registration only 404'd;
// unregister also clears any legacy SW still installed on prod browsers.
unregisterServiceWorker();
